<template>
	<button class="hamburgerMenu" @click="clickHamburgerMenu">
		<img class="hamburgerIcon" src="../../public/img/menu.png" />
	</button>
</template>

<script>
import { mapState } from "vuex";
export default {
	methods: {
		clickHamburgerMenu() {
			this.$store.dispatch("clickHamburger", { value: !this.showAsideMenu });
		}
	},
	computed: {
		...mapState(["showAsideMenu"])
	}
};
</script>
